import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { getPlanogramImageUrl } from 'src/helper/app-utils';

interface DialogData {
  compare_planogram_ids: number[];
  compare_planogram_data: any;
}

@Component({
  selector: 'app-compare-planogram-image-preview',
  templateUrl: './compare-planogram-image-preview.component.html',
  styleUrls: ['./compare-planogram-image-preview.component.css'],
})
export class ComparePlanogramImagePreviewComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: DialogData) {}

  getPlanogramPreviewImageSrc = (id: any) => {
    let user_name = localStorage.getItem('user_name') || '';
    return getPlanogramImageUrl(
      id,
      // this.data.compare_planogram_data[id].name,
      user_name,
      this.data.compare_planogram_data[id].cooler_details.cooler_type,
      false
    );
  };
}
